(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["notify-stock-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__nbsNotifyInit) return;
    window.__nbsNotifyInit = true;

    // Portal the drawer to <body> so it isn't trapped in the product section's
    // stacking context (transformed ancestors) and layers ABOVE the header —
    // same effective placement as the cart drawer.
    function portalNotifyDrawer() {
      var drawers = document.querySelectorAll('drawer-component[drawer-type="notify-stock"]');
      var kept = null;
      drawers.forEach(function (el) {
        if (!kept) {
          if (el.parentElement !== document.body) document.body.appendChild(el);
          kept = el;
        } else {
          el.remove(); // drop any duplicate left by a section re-render
        }
      });
    }
    if (document.readyState !== 'loading') portalNotifyDrawer();
    else document.addEventListener('DOMContentLoaded', portalNotifyDrawer);
    document.addEventListener('shopify:section:load', portalNotifyDrawer);

    document.addEventListener('submit', async function (event) {
      var form = event.target.closest('[data-notify-stock-form]');
      if (!form) return;
      event.preventDefault();

      var emailInput = form.querySelector('input[type="email"]');
      var submitBtn = form.querySelector('button[type="submit"]');
      var statusEl = form.querySelector('[data-notify-status]');

      if (emailInput && !emailInput.checkValidity()) {
        emailInput.reportValidity();
        return;
      }

      // Resolve the currently selected variant from the live product form when present
      // (handles variant switching); fall back to the value rendered into the drawer.
      var productFormId = document.querySelector('product-form [name="id"]');
      var variantId =
        (productFormId && productFormId.value) ||
        form.getAttribute('data-variant-id') ||
        '';

      var payload = {
        email: emailInput ? emailInput.value.trim() : '',
        variant_id: variantId,
        product_id: form.getAttribute('data-product-id') || '',
        product_title: form.getAttribute('data-product-title') || '',
        product_handle: form.getAttribute('data-product-handle') || '',
        locale: document.documentElement.lang || ''
      };

      if (submitBtn) submitBtn.disabled = true;
      form.removeAttribute('data-state');

      try {
        var response = await fetch(form.getAttribute('action'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload)
        });
        if (!response.ok) throw new Error('Request failed: ' + response.status);

        form.setAttribute('data-state', 'success');
        if (statusEl) {
          statusEl.textContent = form.getAttribute('data-success-msg') || '';
          statusEl.hidden = false;
        }
      } catch (error) {
        form.setAttribute('data-state', 'error');
        if (statusEl) {
          statusEl.textContent = form.getAttribute('data-error-msg') || '';
          statusEl.hidden = false;
        }
        if (submitBtn) submitBtn.disabled = false;
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
